import { Image } from "@ui-kit/Image/Image";
import { Text } from "@ui-kit/Text/Text";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { SearchResult } from "@dto/SearchResult";
import { FunctionComponent } from "react";

interface SearchOptionProps {
  data: SearchResult;
}

const SearchOption: FunctionComponent<SearchOptionProps> = ({ data }) => {
  const secondaryText =
    data.entityType === "Event" ? data.dateRange : data.category?.name;

  return (
    <div className="search-option">
      <Image src={data.thumbnailUrl} alt={data.label} />
      <div className="search-option-text">
        <Text variant="fontHeadingXsmall" color={colors.black}>
          {data.label}
        </Text>
        <Text variant="fontBodySmall" color={colors.neutral600}>
          {secondaryText}
        </Text>
      </div>
    </div>
  );
};

export { SearchOption };
